import React from 'react';

import { AudioUploadFailureRow } from './components';
import {
    headerHeight,
    modalFooterShimHeight,
    modalFooterHeight,
    tableHeight,
} from '../../constants';

interface AudioAlertsProps {
    failedUploads: UploadAudioFileOutput[];
}

/**
 * Renders a progress bar for any audio uploads that failed. These are persisted in localStorage and
 * queried using the audioUploads field policy in: packages/resolvers/src/fieldPolicies/audioUploads.ts
 *
 * @param props - see {@link AudioAlertsProps}
 */
export const AudioAlerts = ({
    failedUploads,
}: AudioAlertsProps): JSX.Element => (
        <>
            <div
                className="bg-white rounded-b-lg relative"
                style={{
                    height: tableHeight + modalFooterHeight + headerHeight,
                }}
            >
                <div className="flex flex-col justify-start items-center h-full">
                    <div className="overflow-y-audio overflow-x-hidden respond-to-mouse">
                        {failedUploads.map(
                            (
                                uploadResult: UploadAudioFileOutput,
                            ): JSX.Element => (
                                <AudioUploadFailureRow
                                    uploadResult={uploadResult}
                                    key={uploadResult.id}
                                />
                            ),
                        )}
                    </div>
                </div>
            </div>
            <div style={{ height: modalFooterShimHeight }} />
        </>
    );
